/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const OTPLoginMultiResponseParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('select')],
]);
export class OTPLoginMultiResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return OTPLoginMultiResponseParser.decode(input).map(res => new OTPLoginMultiResponse(res));
    }
    static unsafeDecode(input) {
        return OTPLoginMultiResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return OTPLoginMultiResponseParser.encode(data);
    }
    static schema() {
        return OTPLoginMultiResponseParser.schema();
    }
}
